(function (ng) {
    

    angular.module('defaultButton', []);
})(window.angular);
